export var RootRoutes;
(function (RootRoutes) {
    RootRoutes["Onboarding"] = "/onboard";
    RootRoutes["None"] = "/";
})(RootRoutes || (RootRoutes = {}));
